import {
  LOGIN,
  LOGOUT,
  SHOW_SPINNER,
  HIDE_SPINNER,
  USER_CREATED,
  SHOW_ALERT,
  SET_PROPERTY_USER,
  SET_PROPERTY_LOGIN,
  LEGACY_CUSTOMER,
} from "../types";

const UserReducer = (state, { type, payload }) => {
  switch (type) {
    case LOGIN:
      return { ...state, user: payload, spinner: false };
    case LOGOUT:
      return { ...state, user: null };
    case SHOW_SPINNER:
      return { ...state, spinner: true };
    case HIDE_SPINNER:
      return { ...state, spinner: false };
    case USER_CREATED:
      return { ...state, created: true };
    case SHOW_ALERT:
      return { ...state, error: payload };
    case SET_PROPERTY_USER: {
      const { key, value } = payload;
      const user = { ...state.user };
      user[key] = value;
      return { ...state, user };
    }
    case SET_PROPERTY_LOGIN:
      const { key, value } = payload;
      return { ...state, [key]: value };
    case LEGACY_CUSTOMER:
      return { ...state, legacy: payload };
    default:
      return { ...state };
  }
};

export default UserReducer;
